import setNumberFormat from './number-format.run';

export default angular.module('home.components.lp1.highcharts', [])
  .run(setNumberFormat)
  .name;
